import React from 'react';

import {
  Anchor,
  Button,
  ButtonGroup,
  Checkbox,
  Favorite,
  Field,
  Text,
  Icon,
  Input,
  NewCheckbox,
  NewInput,
  NewRadio,
  NewSelect,
  NewTable,
  NewTextArea,
  Radio,
  Search,
  SelectableList,
  TextArea,
  Tracker,
  VStack,
} from '@carta/ink';

import ExposeDescribe from '../components/ExposeDescribe';

const types = ['default', 'primary', 'inverse', 'danger', 'transparent', 'aura', 'link', 'black', 'underline'] as const;

const sizes = ['auto', 'small', 'wide', 'full', 'mini'] as const;

const DisabledExpose = () => {
  return (
    <>
      <ExposeDescribe id="Disabled visual check" name="Disabled visual check" key="Disabled visual check">
        <NewTable>
          <NewTable.Head>
            <NewTable.Row>
              <NewTable.HeadCell width="20%">Html default</NewTable.HeadCell>
              <NewTable.HeadCell width="40%">Current</NewTable.HeadCell>
              <NewTable.HeadCell width="40%">Old</NewTable.HeadCell>
            </NewTable.Row>
          </NewTable.Head>
          <NewTable.Body>
            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<a>`}</Text>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="javascript:void(0)">test</a>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Anchor>`}</Text>
                  <Anchor isDisabled href="javascript:void(0)">
                    Anchor text
                  </Anchor>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<button>`}</Text>
                  <button disabled>test</button>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small" align="left">
                  <Text variant="body-2" trim>{`<Button>`}</Text>
                  <Button isDisabled>Button A</Button>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell />
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<ButtonGroup>`}</Text>
                  <ButtonGroup>
                    <ButtonGroup.Button isDisabled>Button A</ButtonGroup.Button>
                    <ButtonGroup.Button isDisabled>Button B</ButtonGroup.Button>
                    <ButtonGroup.Button isDisabled>Button C</ButtonGroup.Button>
                  </ButtonGroup>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<select>`}</Text>
                  <select disabled>
                    <option>test</option>
                  </select>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<NewSelect>`}</Text>
                  <NewSelect id="select-3" disabled>
                    <NewSelect.Option value="">Choose a user</NewSelect.Option>
                  </NewSelect>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<textarea>`}</Text>
                  <textarea disabled value="test" />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<NewTextArea>`}</Text>
                  <NewTextArea id="textarea-id-3" disabled />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<TextArea>`}</Text>
                  <TextArea id="textarea-id-3" isDisabled />
                </VStack>
              </NewTable.Cell>
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<input>`}</Text>
                  <input disabled value="test" />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<NewInput>`}</Text>
                  <NewInput disabled value="test" />
                  <NewInput disabled prefix="$" />
                  <NewInput disabled suffix="$" />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Input>`}</Text>
                  <Input isDisabled value="test" />
                </VStack>
              </NewTable.Cell>
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<input type='search'>`}</Text>
                  <input disabled type="search" value="search" />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Search>`}</Text>
                  <Search
                    id="search-4"
                    placeholder="Search"
                    hasFilter
                    isDisabled
                    dropdownFilters={[
                      {
                        id: 'checkbox1',
                        label: 'Checkbox 1',
                        name: 'checkbox1',
                        value: true,
                      },
                      {
                        id: 'checkbox2',
                        label: 'Checkbox 2',
                        name: 'checkbox2',
                        value: false,
                      },
                    ]}
                  />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<input radio>`}</Text>
                  <label htmlFor="radio-test-1">
                    <input id="radio-test-1" disabled type="radio" value="test" />
                    test
                  </label>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<NewRadio>`}</Text>
                  <NewRadio
                    id="input-base2-3"
                    name="new-radio-group-base2"
                    value="3"
                    label="Meetly plan three"
                    checked={false}
                    disabled
                  />
                  <NewRadio
                    id="input-base2-3"
                    name="new-radio-group-base2"
                    value="3"
                    label="Meetly plan three"
                    checked
                    disabled
                  />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Radio>`}</Text>
                  <Radio
                    id="radio-input-example-1"
                    name="radio-input-example-1"
                    size="quarter"
                    isInline
                    options={[
                      {
                        id: 'yes',
                        value: 'yes',
                        label: 'Yes',
                        isDisabled: true,
                      },
                      {
                        id: 'no',
                        value: 'no',
                        label: 'No',
                        isDisabled: true,
                      },
                    ]}
                  />
                </VStack>
              </NewTable.Cell>
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<input checkbox>`}</Text>
                  <label htmlFor="test-checkbox-1">
                    <input id="test-checkbox-1" disabled type="checkbox" value="test" />
                    test
                  </label>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<NewCheckbox>`}</Text>
                  <NewCheckbox disabled id="example-id-1" label="test" />
                  <NewCheckbox disabled id="example-id-1" label="test" checked />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Checkbox>`}</Text>
                  <Checkbox isDisabled id="example-id-1" label="test" />
                </VStack>
              </NewTable.Cell>
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<fieldset>`}</Text>
                  <fieldset disabled>
                    <legend>Choose your favorite monster</legend>
                    <input type="radio" id="kraken" name="monster" />
                    <label htmlFor="kraken">Kraken</label>
                    <br />
                    <input type="radio" id="sasquatch" name="monster" />
                    <label htmlFor="sasquatch">Sasquatch</label>
                    <br />
                    <input type="radio" id="mothman" name="monster" />
                    <label htmlFor="mothman">Mothman</label>
                  </fieldset>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Field>`}</Text>
                  <Field label="Field label goes here" isStacked>
                    <Input id="form-input-example" isDisabled />
                  </Field>
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell />
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Favorite>`}</Text>
                  <Favorite onClick={() => console.log('disabled')} isDisabled />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell />
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<Tracker>`}</Text>
                  <Tracker
                    items={[
                      {
                        label: 'complete',
                        id: '1',
                        href: '#',
                        isComplete: true,
                        isDisabled: true,
                      },
                      {
                        label: 'incomplete',
                        id: '2',
                        href: '#',
                        isComplete: false,
                        isDisabled: true,
                      },
                    ]}
                    active="peers"
                    isHorizontal
                  />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row>
              <NewTable.Cell />
              <NewTable.Cell>
                <VStack spacing="small">
                  <Text variant="body-2" trim>{`<SelectableList>`}</Text>
                  <SelectableList
                    id="selectablelist-disabled-sample"
                    options={[
                      {
                        id: 'selectablelist-disabled-1',
                        value: 'selectablelist-disabled-1',
                        isDisabled: true,
                        content: (
                          <>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut tortor lacinia, imperdiet
                            lorem quis, sodales risus. Mauris maximus urna orci, at viverra sem lobortis quis. Praesent
                            consectetur cursus risus ut suscipit. Vivamus euismod nec nibh eu consequat. Interdum et
                            malesuada fames ac ante ipsum primis in faucibus. Suspendisse imperdiet tortor sed urna
                            hendrerit laoreet. Donec risus magna, tincidunt a hendrerit nec, consequat id diam.
                            Suspendisse feugiat, odio non tincidunt vulputate, dolor tellus eleifend risus, nec faucibus
                            nibh tortor in sem. Duis ut mauris quis mi venenatis tristique.
                          </>
                        ),
                      },
                    ]}
                  />
                </VStack>
              </NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>

            <NewTable.Row preset="lowContrast">
              <NewTable.Cell />
              <NewTable.Cell>{`<NewTable>`} with preset "Low Contrast"</NewTable.Cell>
              <NewTable.Cell />
            </NewTable.Row>
          </NewTable.Body>
        </NewTable>
      </ExposeDescribe>

      <ExposeDescribe
        id="Disabled Button combinations"
        name="Disabled Button combinations"
        key="Disabled Button combinations"
      >
        <NewTable>
          <NewTable.Head>
            <NewTable.Row>
              <NewTable.HeadCell width="30px" />
              {sizes.map(size => (
                <NewTable.HeadCell key={size} width={size === 'full' ? '35%' : '15%'}>
                  {size}
                </NewTable.HeadCell>
              ))}
            </NewTable.Row>
          </NewTable.Head>
          <NewTable.Body>
            {types.map(type => (
              <NewTable.Row key={type}>
                <NewTable.Cell>{type}</NewTable.Cell>
                {sizes.map(size => (
                  <NewTable.Cell key={`${type}-${size}`}>
                    <Button type={type} size={size} isDisabled>
                      Label
                    </Button>
                  </NewTable.Cell>
                ))}
              </NewTable.Row>
            ))}
          </NewTable.Body>
        </NewTable>
      </ExposeDescribe>

      <ExposeDescribe
        id="Disabled Button with Icon combinations"
        name="Disabled Button with Icon combinations"
        key="Disabled Button with Icon combinations"
      >
        <NewTable>
          <NewTable.Head>
            <NewTable.Row>
              <NewTable.HeadCell width="30px" />
              {sizes.map(size => (
                <NewTable.HeadCell key={size} width={size === 'full' ? '35%' : '15%'}>
                  {size}
                </NewTable.HeadCell>
              ))}
            </NewTable.Row>
          </NewTable.Head>
          <NewTable.Body>
            {types.map(type => (
              <NewTable.Row key={type}>
                <NewTable.Cell>{type}</NewTable.Cell>
                {sizes.map(size => (
                  <NewTable.Cell key={`${type}-${size}`}>
                    <Button type={type} size={size} isDisabled>
                      <Icon type="table" />
                      &nbsp; Label
                    </Button>
                  </NewTable.Cell>
                ))}
              </NewTable.Row>
            ))}
          </NewTable.Body>
        </NewTable>
      </ExposeDescribe>
    </>
  );
};

export default DisabledExpose;
